import { createEntityPickerField } from "./createEntityPickerField";
import type { TypedEntityPickerProps } from "./EntityPickerField";
import type { CategoryId } from "../../api/types";

export type CategoryPickerFieldProps = TypedEntityPickerProps<CategoryId>;

export const CategoryPickerField =
  createEntityPickerField<CategoryId>("category");
